import React from "react";
import { MainContainer } from "@components/templates/layouts/main-container/main-container";
import { RoundBorderComponentContainer } from "@components/templates/layouts/round-border-component-container/round-border-component-container";
import { CenterCenterContainer } from "@components/templates/layouts/center-center-container/center-center-container";
import { ErrorPane } from "@components/organisms/error-pane/error-pane";
import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";
import { useI18N } from "@src/language/language-context";

export const ServerErrorPage = () => {
  const i18n = useI18N();

  const texts = {
    hintTitle: i18n("pages.serverError.hintTitle"),
    title: i18n("pages.serverError.title"),
    button: i18n("pages.serverError.button"),
  };

  return (
    <MainContainer>
      <Spacer16 />
      <RoundBorderComponentContainer>
        <CenterCenterContainer>
          <ErrorPane
            hintTitleText={texts.hintTitle}
            titleText={texts.title}
            buttonText={texts.button}
          />
        </CenterCenterContainer>
      </RoundBorderComponentContainer>
    </MainContainer>
  );
};
